// Meta (Facebook) pixel: one PageView per full page load. Loaded by
// app/views/shared/_facebook_pixel.html.erb as a consent-gated script that
// Cookiebot only runs once the visitor accepts marketing cookies. It's a file
// rather than inline because Cookiebot re-creates the script without the CSP
// nonce; served from /assets it's allowed by script-src 'self'.
!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js')

fbq("init", "2196797294201450")
fbq("track", "PageView")
